"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const react_router_dom_1 = require("react-router-dom");
const ErrorPage_1 = require("./components/error-page/ErrorPage");
const firebaseContext_1 = require("./context/firebaseContext");
const AppRoutes_1 = require("./routes/AppRoutes");
require("./styles.scss");
const router = (0, react_router_dom_1.createBrowserRouter)((0, react_router_dom_1.createRoutesFromElements)(react_1.default.createElement(react_router_dom_1.Route, { path: "*", element: react_1.default.createElement(AppRoutes_1.AppRoutes, null), errorElement: react_1.default.createElement(ErrorPage_1.ErrorPage, null) })));
(0, client_1.createRoot)(document.getElementById("root")).render(react_1.default.createElement(firebaseContext_1.FirebaseProvider, null,
    react_1.default.createElement(react_router_dom_1.RouterProvider, { router: router })));
